import ObservationsRiskLevelDonutChart from "./ObservationsRiskLevelDonutChart";
import ObservationsStateDonutChart from "./ObservationsStateDonutChart";

const OBSERVATIONS_STATISTICS_WIDGETS = [
  {
    key: "risk_level",
    component: <ObservationsRiskLevelDonutChart />,
  },
  {
    key: "state",
    component: <ObservationsStateDonutChart />,
  },
];

export {
  OBSERVATIONS_STATISTICS_WIDGETS,
  ObservationsRiskLevelDonutChart,
  ObservationsStateDonutChart,
};
